import { IAction } from '~/src/store';

import { ETicketPayment } from './index';

export type TSetBonusesAmount = IAction<ETicketPayment.SET_BONUSES_AMOUNT, number>

const setBonusesAmount = (amount: number): TSetBonusesAmount => ({
    type: ETicketPayment.SET_BONUSES_AMOUNT,
    payload: amount,
});

export default setBonusesAmount;
